<template>
    <div>
        <!-- <div id="space-div"></div> -->
        <nav id="sidebarMenu" class="sidebar show collapse">
            <div class="position-sticky">
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <router-link :to="{ name: 'home' }" @click.native="getSoundClick" :class="menu_active == 'home'?'nav-link active':'nav-link'">
                            <i class="lisa-icon-menu-home"></i>
                            <span>{{ $t('menu_item_home') }}</span>                        
                        </router-link>
                    </li>
                    <li class="nav-item liveclass" v-if="this.user_info.student_type == 1">
                        <router-link :to="{ name: 'liveclass' }" @click.native="getSoundClick" :class="menu_active == 'liveclass'?'nav-link active':'nav-link'">
                            <i class="lisa-icon-menu-liveclass"></i>
                            <span>{{ $t('live_class') }}</span>    
                            <div v-if="popupClass!=null && popupClass.status == 2">
                                <div class="noti-alert class"></div>               
                            </div>                         
                        </router-link>
                    </li>

                    <!-- Lớp diễn ra trong X phút -->
                    <div class="box-class-comming" v-if="popupClass!=null && popupClass.status != 4 && this.user_info.student_type != 0">
                        <img @click="hidePopup()" style="position: absolute; right: 5px; top: 7px; cursor: pointer;" class="lock-sidebar" src="/themes/ito/images/icons/close-cricle.svg"/>
                        <p class="title-class" >{{$t('class')}}: {{popupClass.class_name}}</p>
                        <p class="subject">{{$t('subject')}}:  {{popupClass.subject}}</p>
                        <div class="block-status" v-if="popupClass.status == 2">
                            <div class="red-dot"></div>
                            <p class="status">{{$t('live_now')}}</p>
                        </div>
                        <button class="join-class" @click="btnJoinClass(popupClass.start_url)" v-if="popupClass.status == 2">{{$t('lisa_web_join_to_class')}}</button>
                        <p class="btn-comming"  v-if="popupClass.status == 1">{{$t('class_comming')}}: <b><countdown :toturing = "popupClass" :key="popupClass.id"/></b></p>
                    </div>
                    <div class="box-comming" @click="showPopup()" style="display: none;">
                       {{ $t('lisa_web_join_to_class') }}
                    </div>
                    <!-- end -->

                    <!-- <li class="nav-item disable" v-if="is_free_trial">
                        <a class="nav-link">
                            <i class="lisa-icon-menu-liveclass"></i>
                            <span>{{ $t('live_class') }}</span>
                        </a>
                        <img class="lock-sidebar" src="https://alpha-v3.ismart.edu.vn/themes/ito/images/icons/icon-lock-sidebar.svg"/>
                    </li>
                    <li class="nav-item" v-if="!is_free_trial">
                        <router-link :to="{ name: 'tutoring' }" @click.native="getSoundClick" :class="menu_active == 'tutoring'?'nav-link active':'nav-link'">
                            <i class="lisa-icon-menu-tutoring"></i>
                            <span>{{ $t('menu_item_tutoring') }}</span>                    
                        </router-link>
                    </li> -->
                    <!-- <li class="nav-item disable" v-if="is_free_trial && this.user_info.student_type == 1">
                        <a class="nav-link">
                            <i class="lisa-icon-menu-tutoring"></i>
                            <span>{{ $t('menu_item_tutoring') }}</span>
                        </a>
                        <img class="lock-sidebar" src="https://alpha-v3.ismart.edu.vn/themes/ito/images/icons/icon-lock-sidebar.svg"/>
                    </li> -->
                    <li class="nav-item" v-if="!is_free_trial">
                        <router-link :to="{ name: 'achievement' }" @click.native="getSoundClick" :class="menu_active == 'achievement'?'nav-link active':'nav-link'">
                            <i class="lisa-icon-menu-mission"></i>
                            <span>{{ $t('menu_item_achievements') }}</span>                    
                        </router-link>
                    </li>
                    <li class="nav-item disable" v-if="is_free_trial">
                        <a class="nav-link">
                            <i class="lisa-icon-menu-mission"></i>
                            <span>{{ $t('menu_item_achievements') }}</span>
                        </a>
                        <img class="lock-sidebar" src="/themes/ito/images/icons/icon-lock-sidebar.svg"/>
                    </li>
                    <li class="nav-item" style="position:relative">
                        <router-link :to="{ name: 'inbox' }" @click.native="getSoundClick" :class="menu_active == 'inbox'?'nav-link active':'nav-link'">
                            <i class="lisa-icon-menu-inbox"></i>
                            <span>{{ $t('inbox') }}</span>     
                            <div v-if="user_info.count_mail_unread != 0">
                                <div class="noti-alert">{{user_info.count_mail_unread < 10 ? user_info.count_mail_unread : '9+' }}</div>               
                            </div>               
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="!is_free_trial">
                        <router-link :to="{ name: 'parent_report' }" @click.native="getSoundClick" :class="menu_active == 'parent'?'nav-link active':'nav-link'">
                            <i class="lisa-icon-menu-report"></i>
                            <span>{{ $t('report') }}</span>                    
                        </router-link>
                    </li>
                    <li class="nav-item disable" v-if="is_free_trial">
                        <a class="nav-link">
                            <i class="lisa-icon-menu-report"></i>
                            <span>{{ $t('report') }}</span>
                        </a>
                        <img class="lock-sidebar" src="/themes/ito/images/icons/icon-lock-sidebar.svg"/>
                    </li>

                    <!-- <li class="nav-item">
                        <router-link :to="{ name: 'simulation' }" @click.native="getSoundClick" :class="menu_active == 'parent'?'nav-link active':'nav-link'">
                            <i class="lisa-icon-menu-report"></i>
                            <span>simulation</span>                    
                        </router-link>
                    </li> -->


                    <button v-if="env== 'local' || env == 'test'" @click="switchKey()" style="width: 80px;">Switch key</button>
                    <button v-if="env == 'local' || env == 'test'" @click="switchKey1()" style="width: 80px;">Switch value</button>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
    import axios from 'axios'
    import {mapGetters} from 'vuex'
    import {getMenus} from '../models/menu'
    import $ from 'jquery'
    import {soundClick} from '../utils/utils'
    import { getClassess, getTutorings, getTutoringsInComming } from "../models/live_class";
    import CountdownStartClass from './element/CountdownStartClass.vue';
    import Countdown from './element/Countdown.vue';


    export default {
        name: "SideBar",

        components: { CountdownStartClass, Countdown },


        data() {
            const time_current = Math.floor(Date.now() / 1000);
            return {
                menus: [],
                is_free_trial: false,
                tutorings: [],
                live_classes: [],
                popupClass: null,
                env: '',
            };
        },

        created() {
            this.fetch();
        },

        mounted(){
            this.env = process.env.VUE_APP_ENV
        },

        computed: {
            user_info() {
                return this.$store.state.user_info
            },
            menu_active() {
                return this.$store.state.menu_active
            },
            live_class_data() {
                return this.$store.state.live_classes;
            },
        },

        updated: function () {
            this.$nextTick(function () {
                //App.init();
            })
        },

        methods: {
            hidePopup(){
                $('.box-class-comming').hide()
                $('.box-comming').show()
            },
            showPopup(){
                $('.box-class-comming').show()
                $('.box-comming').hide()
            },
            btnJoinClass(url){
                window.open(url)                      
            },
            switchKey(){
                localStorage.setItem('show_key', false)
                window.location.reload()
            },
            switchKey1(){
                localStorage.setItem('show_key', true)
                window.location.reload()
            },
            popup(liveclass){
                let listClassComming = []
                let listClassStarted = []
                liveclass.forEach(element => {
                    if(element.status == 1){
                        listClassComming.push(element)      
                    }else if(element.status == 2){
                        listClassStarted.push(element)     
                        this.popupClass =  element   
                    }
                });

                let firstComming = []
                if(listClassComming.length != 0){
                    listClassComming.forEach((lstCM , index) => {
                        firstComming.push(lstCM.time_start)
                    })
                    const min = Math.min(...firstComming)
                    const index = firstComming.indexOf(min)
                    this.popupClass =  listClassComming[index]
                }

                // let lastStarted = []
                // if(listClassStarted.length != 0){
                //     listClassStarted.forEach((lstCS , index) => {
                //         lastStarted.push(lstCS.time_start)
                //     })
                //     const max = Math.max(...lastStarted)
                //     const index1 = lastStarted.indexOf(max)
                //     this.popupClass =  listClassStarted[index1]
                // }
            },

            fetch() {
                this.getTutoringsInComming();
                if(this.user_info.account_type  == 1){
                    this.is_free_trial = true
                }else{
                    this.is_free_trial = false
                }
            },

            async getTutoringsInComming(){
                const that = this;
                await axios.all([getTutoringsInComming({
                    tooltip: true,
                })]).then(
                    axios.spread((response) => {
                        that.$store.commit("setLoading", false);
                        if (response.data.code != 0) {
                            that.tutorings = [];
                            return;
                        }
                        try {
                            that.tutorings = response.data.results?response.data.results.class : [];
                            that.live_classes = response.data.results?response.data.results.class : [];
                            this.$store.commit("setLiveClasses", response.data.results?response.data.results.class : []);

                            this.popup(that.live_classes);

                            this.$nextTick(function() {
                                var swiper = new Swiper(".mySwiper", {
                                    slidesPerView: 2,
                                    //centeredSlides: true,
                                    spaceBetween: 20,
                                    pagination: {
                                        el: ".swiper-pagination",
                                        type: "fraction",
                                    },
                                    navigation: {
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                });    
                            });              
                        } catch (error) {
                            console.error(error);
                        }
                    })
                );
            },

            getSoundClick() {
                soundClick();
            },

            onLogout(e) {
                this.$store.dispatch('logout').then(() => {
                    localStorage.removeItem('is_login');
                    window.location.href = "/login";
                });

                e.preventDefault();
            },
        }
    }
</script>

<style scoped>
    .nav-item.disable{
        position: relative;
    }
    .lock-sidebar{
        position: absolute;
        top: 15px;
        right: 15px;
    }
    .disable .lisa-icon-menu-tutoring:hover, #sidebarMenu .nav-item.disable .nav-link.active .lisa-icon-menu-tutoring{
        background-position: -71px -74px;
    }
    .disable .lisa-icon-menu-liveclass:hover, #sidebarMenu .nav-item.disable .nav-link.active .lisa-icon-menu-liveclass{
        background-position: -71px -74px;
    }
    .disable .lisa-icon-menu-mission:hover, #sidebarMenu .nav-item.disable .nav-link.active .lisa-icon-menu-mission {
        background-position: -71px -152px;
    }
    .disable .lisa-icon-menu-report:hover, #sidebarMenu .nav-item.disable .nav-link.active .lisa-icon-menu-report {
        background-position: -70px -311px;
    }
    .noti-alert{
        position: absolute;
        width: 16px;
        height: 16px;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #F04821;
        box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.25);
        border-radius: 50%;
        font-size: 10px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
        justify-content: center;
        top: 22px;
        right: 25px;
    }

    .noti-alert.class{
        top: 11px;
        right: 15px;
    }
    .position-sticky{
        margin-top: 29px;
    }
    .liveclass{
        position: relative;
    }
    .box-class-comming{
        position: absolute;
        width: 160px;
        /* height: 112px; */
        left: 87px;
        top: 105px;
        padding: 12px;
        background: #FFFFFF;
        box-shadow: 4px 10px 20px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        font-size: 12px;
    }
    .box-comming{
        position: absolute;
        width: 110px;
        height: 24px;
        left: 40px;
        top: 148px;
        padding: 12px;
        background: linear-gradient(180deg, #A7DF3D 0%, #96DB16 100%);
        box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.07);
        border-radius: 4px 4px;
        color: #fff;
        font-size: 12px;
        transform: rotate(90deg);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .box-class-comming .title-class{
        color: #00A3FF;
        font-weight: 700;
        margin-bottom: 4px;
    }
    .box-class-comming .subject{
        color: #000000;
        margin-bottom: 4px;
    }
    .box-class-comming .status{
        color: #FA450F;
        font-weight: 700;
        margin-bottom: 0px;
    }
    .box-class-comming .join-class{
        background: linear-gradient(180deg, #A7DF3D 0%, #96DB16 100%);
        box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.07);
        border-radius: 4px;
        color: #FFFFFF;
        width: 136px;
        height: 24px;
        text-align: center;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .red-dot{
        width: 8px;
        height: 8px;
        background: #FA450F;
        border-radius: 50%;
        margin-right: 4px;
    }
    .block-status{
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        align-self: center;
    }
    .btn-comming{
        color: #000000;
        font-weight: 400;
        font-size: 12px;
        padding: 0;
        margin: 0;
    }
</style>
